import { cva } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import tinycolor from 'tinycolor2';

const chipVariants = cva('text-white rounded-2xl font-medium', {
  variants: {
    variant: {
      small: 'px-2 py-[2px] text-xs',
      medium: 'px-3 py-1 text-sm',
    },
  },
  defaultVariants: {
    variant: 'medium',
  },
});

interface IBenchmarkChipProps {
  label: string;
  scoreRange?: number | string;
  color?: string;
  className?: string;
  variant?: 'small' | 'medium';
}

function BenchmarkChip({
  label,
  scoreRange,
  color,
  className,
  variant,
}: IBenchmarkChipProps) {
  const isCustomColor = color?.startsWith('#') || color?.startsWith('var(');
  const { t } = useTranslation();

  const textColor = tinycolor(color).isLight() ? 'text-grey-800' : 'text-white';

  return (
    <div className="flex items-center gap-x-2">
      <span
        className={twMerge(chipVariants({ variant }), textColor, className)}
        style={isCustomColor && color ? { backgroundColor: color } : undefined}
      >
        {label}
      </span>
      {scoreRange && (
        <span className="text-grey-900 text-xs font-medium">
          {t('SCORE')}: {scoreRange}
        </span>
      )}
    </div>
  );
}

export default BenchmarkChip;
